<template>
  <ConsentPromotion :promotion-info="promotionInfo" />
</template>
<script setup>
  import { defineProps, computed } from 'vue'
  import ConsentPromotion from '@/components/consent/ConsentPromotion.vue'

  const props = defineProps({
    payloads: {
      type: Object,
      default: () => ({}),
    },
  })
  const promotionInfo = computed(() => props.payloads?.info ?? {})
</script>
